const bootbox = require('bootbox').init($)

bootbox.setLocale('de')

const buttons = {
  cancel: {
    className: 'btn-link'
  }
}

export default function turboConfirm(message) {
  return new Promise((resolve) => {
    bootbox.confirm({ message, buttons, callback: resolve })
  })
}
